/**
 * @class {T.Popup}
 * @extends {mkE.Base}
 * @param par
 */
T.Popup = Class(
	/**
	 * @lends {T.Popup#}
	 */
	{
		__NAME: 'T.Popup',

		_isBodyOverflowing: false,
		_scrollbarWidth: 0,
		_closeOnClick: false,

		/**
		 *
		 * @param par
		 * @constructs
		 */
		__construct( par ) {
			this.par = par || {};

			this.node = mkE({
				tag: 'div',
				className: 'popup' + (this.par.className ? ' ' + this.par.className : ''),
				els: [
					{
						tag: 'div',
						className: 'popup-window',
						els: [
							{
								tag: 'div',
								className: 'popup-header',
								els: [
									this._titleNode = mkE({
										tag: 'div',
										className: 'popup-title'
									}),
									{
										tag: 'button',
										className: 'popup-close',
										onclick: this.close,
										els: [
											D.svgIcon('close')
										]
									}
								]
							},
							this._contentNode = mkE({
								tag: 'div',
								className: 'popup-content'
							})
						]
					}
				],
				onclick: this.onclick
			});
		},

		onclick( e ) {
			if( this.par.overlayClick === false ) {
				return;
			}
			if( this.node.contains(e.target) && e.target !== this.node && !this._closeOnClick ) {
				return;
			}
			this.close();
		},

		open() {
			this._checkScrollbar();
			this._setScrollbar();
			this._adjustDialog();
			this.node.append(document.body);
			T.Popup._inst.push(this);
		},

		close() {
			this.node.remove();
			let index = T.Popup._inst.indexOf(this);
			if( index !== -1 ) {
				T.Popup._inst.splice(index, 1);
			}
			if( empty(T.Popup._inst) ) {
				removeClassName(document.body, 'popup-open');
				this._resetAdjustments();
				this._resetScrollbar();
			}
			if( this.par.onClose ) {
				this.par.onClose();
			}
		},

		_adjustDialog() {
			const isModalOverflowing = this.node.scrollHeight > document.documentElement.clientHeight;

			if( !this._isBodyOverflowing && isModalOverflowing ) {
				this.node.style.paddingLeft = this._scrollbarWidth + 'px';
			}

			if( this._isBodyOverflowing && !isModalOverflowing ) {
				this.node.style.paddingRight = this._scrollbarWidth + 'px';
			}
		},

		_resetAdjustments() {
			this.node.style.paddingLeft = '';
			this.node.style.paddingRight = '';
		},

		_checkScrollbar() {
			const rect = document.body.getBoundingClientRect();
			this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
			this._scrollbarWidth = this._getScrollbarWidth();
		},

		_setScrollbar() {
			if( this._isBodyOverflowing ) {
				const actualPadding = document.body.style.paddingRight;
				const calculatedPadding = $(document.body).css('padding-right');
				$(document.body).data('padding-right', actualPadding).css('padding-right', (parseFloat(calculatedPadding) + this._scrollbarWidth) + 'px');
			}
			$(document.body).addClass('popup-open');
		},

		_resetScrollbar() {
			const padding = $(document.body).data('padding-right');
			$(document.body).removeData('padding-right');
			document.body.style.paddingRight = padding ? padding : '';
		},

		_getScrollbarWidth() {
			const scrollDiv = mkE({
				tag: 'div',
				className: 'popup-scrollbar-measure'
			}).append(document.body);
			const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
			scrollDiv.remove();
			return scrollbarWidth
		},

		setVideoContent( content ) {
			addClassName(this.node, 'video');
			mkE({
				tag: 'div',
				className: 'popup-video',
				els: [
					{
						tag: 'div',
						className: 'video-wrap',
						els: [
							content
						]
					}
				]
			}).append(this._contentNode);
		},

		setImage( url ) {
			this._closeOnClick = true;
			mkE({
				tag: 'div',
				className: 'popup-image',
				style: {
					backgroundImage: 'url(' + url + ')'
				}
			}).append(this._contentNode);
		},

		setTitle( title ) {
			clearNode(this._titleNode);
			mkE.appendTypeElement(this._titleNode, title);
		},

		setContent( content ) {
			clearNode(this._contentNode);
			mkE.appendTypeElement(this._contentNode, content);
		}
	},
	mkE.Base
);
T.Popup._inst = [];
T.Popup.close = function () {
	if( empty(T.Popup._inst) ) {
		return;
	}
	let popup = T.Popup._inst[T.Popup._inst.length - 1];
	if( !popup ) {
		return;
	}
	popup.close();
};
T.Popup.image = function ( url ) {
	let popup = new T.Popup();
	popup.setImage(url);
	popup.open();
};
T.Popup.video = function ( content ) {
	let popup = new T.Popup();
	popup.setVideoContent(content);
	popup.open();
};
T.Popup.clip = function ( src, width, height ) {
	let popup = new T.Popup({
		className: 'popup-gallery'
	});
	popup.setContent({
		tag: 'div',
		className: 'wrapper',
		els: [
			{
				tag: 'div',
				className: 'image',
				els: [
					{
						tag: 'video',
						src: src,
						width: width,
						height: height,
						attr: {
							preload: 'auto',
							autoplay: true,
							playsinline: true,
							controls: true
						}
					}
				]
			}
		]
	});
	popup.open();
};

/**
 * @class
 * @param {T.Popup.Gallery.Par} par
 * @extends mkE.Base
 */
T.Popup.Gallery = Class(
	/**
	 * @lends {T.Popup.Gallery#}
	 */
	{
		/** @type {int} */
		_index: 0,
		/** @type {int} */
		_loadTimeout: 0,
		/**
		 * @param {Array<String>} images
		 * @param {int|null} index
		 * @private
		 */
		__construct: function ( images, index ) {
			this.images = images;
			index = index || 0;

			this.node = mkE({
				tag: 'div',
				className: 'wrapper',
				ontouchstart: this.onTouchStart,
				ontouchend: this.onTouchEnd,
				els: [
					this._btnPrevNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-prev',
						onclick: this.prev,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-left')
						]
					}),
					{
						tag: 'div',
						className: 'image',
						els: [
							this._imageNode = mkE({
								tag: 'img'
							})
						]
					},
					this._btnNextNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-next',
						onclick: this.next,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-right')
						]
					})
				]
			});

			if( this.images.length > 1 ) {
				this._btnNextNode.style.display = '';
				this._btnPrevNode.style.display = '';
			}

			this.goTo(index);
		},
		/**
		 * @returns {T.Popup.Gallery}
		 */
		popup() {
			this._modal = new T.Popup({
				className: 'popup-gallery',
				onClose: this._onClosePopup
			});
			this._modal.setContent(this.node);
			this._modal.open();
			document.addEventListener('keyup', this._onKeyUp);
			if( window.screen && typeof screen.orientation !== 'undefined' ) {
				screen.orientation.addEventListener('change', this._onChangeOrientation);
			}
			return this;
		},
		/**
		 * @param {int} index
		 * @returns {boolean}
		 */
		goTo( index ) {
			if( index < 0 || index >= this.images.length ) {
				return false;
			}

			clearTimeout(this._loadTimeout);
			this._loadTimeout = setTimeout(this._onLoadTimeout, 600);

			this._image = new Image();
			this._image.onload = this._onLoadImage;
			this._image.onerror = this._onLoadImageError;
			this._image.src = this.images[index];

			this._index = index;

			return true;
		},
		/** @returns {T.Popup.Gallery} */
		prev() {
			if( !this.goTo(this._index - 1) ) {
				this.goTo(this.images.length - 1);
			}
			return this;
		},
		/** @returns {T.Popup.Gallery} */
		next() {
			if( !this.goTo(this._index + 1) ) {
				this.goTo(0);
			}
			return this;
		},
		/** @param {TouchEvent} e */
		onTouchStart( e ) {
			this.startX = e.changedTouches[0].screenX;
			this.startY = e.changedTouches[0].screenY;
		},
		/** @param {TouchEvent} e */
		onTouchEnd( e ) {
			const diffX = e.changedTouches[0].screenX - this.startX;
			const diffY = e.changedTouches[0].screenY - this.startY;
			const ratioX = Math.abs(diffX / diffY);
			const ratioY = Math.abs(diffY / diffX);
			const absDiff = Math.abs(ratioX > ratioY ? diffX : diffY);

			// Ignore small movements.
			if( absDiff < 30 ) {
				return;
			}

			if( ratioX > ratioY ) {
				if( diffX >= 0 ) {
					this.prev();
				} else {
					this.next();
				}
			}
		},
		/** @private */
		_onLoadTimeout() {
			if( !this._loaderNode ) {
				this._loaderNode = mkE({
					tag: 'div',
					className: 'loading',
					els: [
						{
							tag: 'span',
							els: [
								D.svgIcon('logo-small')
							]
						}
					]
				});
			}
			this._loaderNode.append(this._imageNode.parentElement);
		},
		_rescale() {
			let re = {
				width: 0,
				height: 0
			}
			const maxHeight = window.innerHeight / 100 * 90;
			const maxWidth = window.innerWidth / 100 * 90;
			re.width = this._image.width;
			re.height = this._image.height;
			const scale = Math.min(maxHeight / re.height, maxWidth / re.width);
			if( scale < 1 ) {
				re.width *= scale;
				re.height *= scale;
			}
			return re;
		},
		/** @private */
		_onLoadImage() {
			clearTimeout(this._loadTimeout);
			if( this._loaderNode ) {
				this._loaderNode.remove();
			}
			let scale = this._rescale();
			this._imageNode = mkE({
				tag: 'img',
				src: this._image.src,
				width: scale.width,
				height: scale.height
			}).replace(this._imageNode);
		},
		/** @private */
		_onLoadImageError() {
			this._onLoadImage();
		},
		/** @private */
		_onClosePopup() {
			document.removeEventListener('keyup', this._onKeyUp);
			if( window.screen && typeof screen.orientation !== 'undefined' ) {
				screen.orientation.removeEventListener('change', this._onChangeOrientation);
			}
			clearTimeout(this._loadTimeout);
		},
		/**
		 * @param {KeyboardEvent} e
		 * @private
		 */
		_onKeyUp( e ) {
			if( e.key === 'ArrowRight' ) {
				this.next();
			} else if( e.key === 'ArrowLeft' ) {
				this.prev();
			} else if( e.key === 'Escape' ) {
				this._modal.close();
			}
		},
		/**
		 * @param {Event} e
		 * @private
		 */
		_onChangeOrientation( e ) {
			if( !this._image.complete ) {
				return;
			}
			let scale = this._rescale();
			this._imageNode.width = scale.width;
			this._imageNode.height = scale.height;
		}
	},
	mkE.Base
);

T.Popup.Gallery.open = function ( images, index ) {
	return (new T.Popup.Gallery(images, index)).popup();
};